// extracted by mini-css-extract-plugin
export default {"cta":"DownloadOrderXml_cta__OKHmV","hidden-trigger":"DownloadOrderXml_hidden-trigger__Ng5NB"};